import { qualifyUrls } from "routing/Routes";
export const reportsPrefix = "/reports";
export const contentSuffix = "/content";
export const deliverySuffix = "/delivery";
export const styleSuffix = "/style";
export const shareSuffix = "/share";
const ReportRoutes = {
  OVERVIEW: reportsPrefix,
  NEW: `${reportsPrefix}/new`,
  CREATE: {
    CONTENT: `${reportsPrefix}/new${contentSuffix}`,
    DELIVERY: `${reportsPrefix}/new${deliverySuffix}`,
    STYLE: `${reportsPrefix}/new${styleSuffix}`,
    SHARE: `${reportsPrefix}/new${shareSuffix}`
  },
  contents: (reportId = ":reportId") => `${reportsPrefix}/${reportId}/contents`,
  archive: (reportId = ":reportId") => `${reportsPrefix}/${reportId}/archive`,
  render: (reportId = ":reportId") => `${reportsPrefix}/${reportId}/render`,
  EDIT: {
    overview: (reportId = ":reportId") => `${reportsPrefix}/${reportId}/contents`,
    content: (reportId = ":reportId") => `${reportsPrefix}/${reportId}/contents${contentSuffix}`,
    delivery: (reportId = ":reportId") => `${reportsPrefix}/${reportId}/contents${deliverySuffix}`,
    style: (reportId = ":reportId") => `${reportsPrefix}/${reportId}/contents${styleSuffix}`
  }
};
const routes = qualifyUrls(ReportRoutes);
export default {
  ...routes,
  unqualified: ReportRoutes
};
